import {
  GET_LOTTERY_MY_TICKET_LIST_REQUEST,
  GET_LOTTERY_MY_TICKET_LIST_SUCCESS,
  GET_LOTTERY_MY_TICKET_LIST_FAILURE,
  GET_LOTTERY_MY_TICKET_LIST_RESET,
  GET_LOTTERY_MY_TICKET_DETAIL_REQUEST,
  GET_LOTTERY_MY_TICKET_DETAIL_SUCCESS,
  GET_LOTTERY_MY_TICKET_DETAIL_FAILURE,
  GET_LOTTERY_MY_TICKET_DETAIL_RESET,
  LOTTERY_MY_TICKETS_TABS
} from 'Store/constants';

const initialState = {
  tabs: {
    data: {}
  },
  ticketList: {
    data: {
      tickets: []
    },
    isLoading: null,
    error: null,
    pagination: {
      pageSize: 10,
      pageIndex: 0,
      hasMore: null,
      start: 1,
      end: 11
    }
  },
  ticketDetail: {
    data: {},
    isLoading: null,
    error: null
  }
};

export default (state = initialState, action) => {
  switch (action.type) {

    case GET_LOTTERY_MY_TICKET_LIST_REQUEST:
      return {
        ...state,
        ticketList: {
          ...state.ticketList,
          isLoading: true,
          error: null
        }
      };

    case GET_LOTTERY_MY_TICKET_LIST_SUCCESS:
      return {
        ...state,
        ticketList: {
          data: {
            tickets: [...state.ticketList.data.tickets, ...action.payload.tickets]
          },
          isLoading: false,
          error: null,
          pagination: {
            ...state.ticketList.pagination,
            ...action.pagination
          }
        }
      };

    case GET_LOTTERY_MY_TICKET_LIST_FAILURE:
      return {
        ...state,
        ticketList: {
          ...state.ticketList,
          isLoading: false,
          error: action.payload,
          pagination: {
            ...state.ticketList.pagination,
            hasMore: false
          }
        }
      };
    
    case GET_LOTTERY_MY_TICKET_LIST_RESET:
      return {
        ...state,
        ticketList: initialState.ticketList
      };

    case GET_LOTTERY_MY_TICKET_DETAIL_REQUEST:
      return {
        ...state,
        ticketDetail: {
          ...state.ticketDetail,
          isLoading: true,
          error: null
        }
      };

    case GET_LOTTERY_MY_TICKET_DETAIL_SUCCESS:
      return {
        ...state,
        ticketDetail: {
          data: action.payload,
          isLoading: false,
          error: null
        }
      };

    case GET_LOTTERY_MY_TICKET_DETAIL_FAILURE:
      return {
        ...state,
        ticketDetail: {
          ...state.ticketDetail,
          isLoading: false,
          error: action.payload
        }
      };

    case GET_LOTTERY_MY_TICKET_DETAIL_RESET:
      return {
        ...state,
        ticketDetail: {
          ...initialState.ticketDetail
        }
      };

    case LOTTERY_MY_TICKETS_TABS:
      return {
        ...state,
        tabs: {
          data: action.payload
        }
      };

    default:
      return state;
  }
};
